import { FlexColumn } from "Routes/styled";
import styled from "styled-components";
import { useDesktopMediaQuery } from "hooks";
import { Body2, H2, H3 } from "melodies-source/Text";
import Skeleton from "react-loading-skeleton";
import { EventCardBaseContainer, RightSideContainer } from "./EventCardBase";

export const EventCardLoader = () => {
  const isDesktop = useDesktopMediaQuery();
  const Venue = !isDesktop ? H3 : H2;
  const Info = !isDesktop ? Body2 : H3;

  return (
    <EventCardBaseContainer isElevated live={false}>
      <StyledMapPinLoader>
        <Skeleton
          circle
          width={isDesktop ? 93 : 75}
          height={isDesktop ? 93 : 75}
        />
      </StyledMapPinLoader>
      <FlexColumn>
        <Venue>
          <Skeleton width={isDesktop ? 200 : 150} />
        </Venue>
        <Info>
          <Skeleton width={isDesktop ? 300 : 200} />
        </Info>
      </FlexColumn>
      <RightSideContainer>
        <ActionButtonLoader>
          <Skeleton height={isDesktop ? 44 : 36} width="100%" />
        </ActionButtonLoader>
      </RightSideContainer>
    </EventCardBaseContainer>
  );
};

const ActionButtonLoader = styled.div`
  min-width: 150px;
  margin-left: auto;
  width: 100%;

  ${({ theme }) => theme.media.desktop} {
    max-width: 180px;
  }

  ${({ theme }) => theme.media.mobile} {
    margin-right: auto;
    margin-top: 15px;
  }
`;

const StyledMapPinLoader = styled.div`
  width: 93px;
  height: 93px;
  margin-right: 17px;

  ${({ theme }) => theme.media.mobile} {
    width: 75px;
    height: 75px;
    margin: 15px 0 20px;
  }
`;
